import React from 'react'
import { Button } from '~/components'
import * as st from '~/assets/styl/Ebook.module.styl'
import { useContext, useLanguage } from '~/hooks'

export default function Ebook() {
  const { t } = useLanguage()
  const { openEbookModal } = useContext()
  return (
    <section className={st.core}>
      <div className={st.title}>
        <h2>{t('Ebook.title')}</h2>
      </div>
      <div className={st.cta}>
        <p>{t('Ebook.paragraph')}</p>
        <Button outlined onClick={() => openEbookModal()}>
          {t('Ebook.button')}
        </Button>
      </div>
    </section>
  )
}
